
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Card,
  Typography,
  Box,
  CircularProgress,
  Button,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';

// actions
import { getEvent } from '@pingum/app-state-management/event/actions';
import { getTags } from '@pingum/app-state-management/tag/actions';
import { getTagTypes } from '@pingum/app-state-management/tagType/actions';
import { getEventData } from '@pingum/app-state-management/eventData/actions';
import { getEventNotificationsForEvent } from '@pingum/app-state-management/eventNotification/actions';
import { Info } from '@mui/icons-material';
// components
import Page from '../Page';

// utils
import EventDataCard from './EventDataCard';

import styles from './styles';
import { setGlobalModals } from '../../redux/app/actions';
import { TASK_MODAL_TYPE } from '../../redux/app/types';

function isNumeric(str) {
  if (typeof str !== 'string') return false // we only process strings!
  return !Number.isNaN(str) // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    && !Number.isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}
export class TaskDetailPageComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = { loadingTimeout: true };

    if (props.tagTypes.length === 0) {
      props.getTagTypes();
    }

    if (props.tags.length === 0) {
      props.getTags();
    }

    if (props.eventData.length === 0) {
      props.getEventData();
    }

    const id = window.location.pathname.indexOf('horses') < 0 && window.location.pathname.replace(/^\/tasks[/]?/, '').replace(/\//g, '');
    // If the ID is present in the URL, we are on task page and always need to load the full task and schedule objects
    // Only passing in the id will tell the global action to get event and schedule
    if (id && id !== props.selectedEvent.id && !(Number.isNaN(parseInt(id, 10)))) {
      props.setSelectedTask({ id: parseInt(id, 10) }, null);
    }

    // this.handleOpenScheduleModal = this.handleOpenScheduleModal.bind(this)
    // this.handleCopySchedule = this.handleCopySchedule.bind(this)
  }

  componentDidMount() {
    setTimeout(() => {
      // 5 second timeout to load event data when selecting a calendar item of task type in past
      this.setState({ loadingTimeout: false })
    }, [5000])
  }

  componentDidUpdate(prevProps) {
    const urlId = window.location.pathname.indexOf('horses') < 0 && window.location.pathname.replace(/^\/tasks[/]?/, '').replace(/\//g, '');
    const prevId = prevProps.selectedEvent.id;
    const currentId = this.props.selectedEvent.id;

    if (
      (urlId && isNumeric(urlId))
      && prevId
      && currentId
      && urlId !== currentId.toString()
      && !(Number.isNaN(parseInt(urlId, 10)))
    ) {
      this.props.setSelectedTask({ id: parseInt(urlId, 10) }, TASK_MODAL_TYPE);
    }
  }

  render() {
    const {
      permissions,
      selectedEvent,
      selectedBarn,
      schedule,
      classes,
      isFetching,
      action,
      tags: propTags,
      tagTypes,
      eventData: propEventData,
      canAttachFiles,
      hidePageWrapper,
      // handleOpen,
      handleClose,
      // fullScreen,
      isUpdatingEvent,
    } = this.props;

    const eventDataCard = (
      <EventDataCard
        selectedEvent={selectedEvent}
        schedule={schedule}
        isCalendarEvent={!!(schedule && schedule.tags
          && schedule.tags.find((t) => t.id === selectedBarn.barnMetadata.eventTaskTypeTagId))}
        classess={classes}
        tags={propTags}
        tagTypes={tagTypes}
        eventData={propEventData}
        isAdmin={permissions.admin || permissions.owner}
        isRestricted={permissions.isRestricted}
        isFetching={isFetching}
        getEvent={this.props.getEvent}
        canAttachFiles={canAttachFiles}
        showLoadingIndicator={isFetching}
        // openScheduleModal={this.handleOpenScheduleModal}
        // handleCopySchedule={this.handleCopySchedule}
        // handleOpen={hidePageWrapper && handleOpen}
        handleClose={hidePageWrapper && handleClose}
        // fullScreen={fullScreen}
        isUpdatingEvent={isUpdatingEvent}
        selectedBarn={selectedBarn}
      />
    )

    const content = (
      (isFetching || (!selectedEvent || !selectedEvent.id))
        ? (

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              p: 4,
            }}
          >
            {
              this.state.loadingTimeout
                ? (
                  <CircularProgress />
                )
                : (
                  <Info color="secondary" />
                )
            }
            <Typography
              sx={{
                fontWeight: 300,
                mt: 2,
                textWrap: 'auto',
              }}
            >
              {
                this.state.loadingTimeout
                  ? 'Loading task details, please wait a moment...'
                  : 'The task you selected does not appear to exist. It could have been deleted or moved.'
              }
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 4,
              }}
            >
              <Button onClick={hidePageWrapper && handleClose}>Close</Button>
            </Box>
          </Box>
        )
        : (eventDataCard)
    );

    return hidePageWrapper
      ? (content)
      : (
        <Page
          title="Task Detail"
          showLoadingIndicator={isFetching}
          disableToolbarGutters
          action={action}
          className={classes.container}
        >
          <Card>
            {content}
          </Card>
        </Page>
      );
  }
}

TaskDetailPageComponent.propTypes = {
  handleClose: PropTypes.func,
  // handleOpen: PropTypes.func,
  permissions: PropTypes.object,
  action: PropTypes.any,
  selectedEvent: PropTypes.object,
  schedule: PropTypes.object,
  // eslint-disable-next-line react/no-unused-prop-types
  scheduleEvents: PropTypes.array,
  getEvent: PropTypes.func,
  classes: PropTypes.object,
  getTags: PropTypes.func,
  getTagTypes: PropTypes.func,
  getEventData: PropTypes.func,
  isFetching: PropTypes.bool,
  tags: PropTypes.array,
  tagTypes: PropTypes.array,
  eventData: PropTypes.array,
  canAttachFiles: PropTypes.bool,
  hidePageWrapper: PropTypes.bool,
  setSelectedTask: PropTypes.func,
  selectedBarn: PropTypes.object,
  isUpdatingEvent: PropTypes.bool,
};

TaskDetailPageComponent.defaultProps = {
  handleClose: () => { },
  // handleOpen: () => {},
  permissions: {},
  action: null,
  selectedEvent: {},
  schedule: null,
  scheduleEvents: [],
  getEvent: () => { },
  classes: {},
  getTags: () => { },
  getTagTypes: () => { },
  getEventData: () => { },
  isFetching: false,
  tags: [],
  eventData: [],
  tagTypes: [],
  canAttachFiles: false,
  hidePageWrapper: false,
  // setSelectedSchedule: () => {},
  setSelectedTask: () => { },
  selectedBarn: {},
  // barnUsersMap: {},
  // fullScreen: false,
  isUpdatingEvent: false,
};

export const mapStateToProps = (state) => ({
  permissions: state.user.permissions,
  selectedEvent: state.event.selectedEvent,
  schedule: state.schedule.schedule,
  scheduleEvents: state.schedule.scheduleEvents,
  statuses: state.status.statuses,
  isFetching:
    state.event.isFetchingEvent
    || state.status.isFetchingStatuses
    || state.schedule.isFetchingSchedule,
  isUpdatingEvent: state.event.isUpdatingEvent,
  tags: state.tag.tags,
  tagTypes: state.tagType.tagTypes,
  eventData: state.eventData.eventData,
  canAttachFiles: true, // TODO are we going to restrit this for trial or lower tier plans?
  barnUsers: state.barn.barnUsers,
  selectedBarn: state.barn.selectedBarn,
  // barnUsersMap: state.barn.barnUsersMap,
});

export const mapDispatchToProps = (dispatch) => ({
  getEvent: (id) => dispatch(getEvent(id)),
  getTags: () => dispatch(getTags(false, false)),
  getTagTypes: () => dispatch(getTagTypes(false, false)),
  getEventData: () => dispatch(getEventData(false)),
  getEventNotificationsForEvent: (id) => dispatch(getEventNotificationsForEvent(id)),
  // eslint-disable-next-line max-len
  // setSelectedSchedule: (modal, schedule, event, refreshCallback, config) => dispatch(setGlobalModals(modal, null, schedule, event, config, refreshCallback)),
  setSelectedTask: (task, modal) => dispatch(setGlobalModals(modal, task, null, null, {}, null)),
});

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps,
)(TaskDetailPageComponent));
